module.exports = __webpack_public_path__ + "c9f458a5381ecdf46e799713642b86cf.png";